import bootstrap from './bootstrap'
import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'
import PortalVue from 'portal-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import googleConfig from '@/config/google'
import Vuelidate from 'vuelidate'
import VueGAPI from 'vue-gapi'
import VueContentPlaceholders from 'vue-content-placeholders'
import VueLazyload from 'vue-lazyload'
import VueMeta from 'vue-meta'
import VueGtm from "vue-gtm"
import './modal'
import './filters'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret, faInfo,faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueClipboard from 'vue-clipboard2'
import * as Sentry from "@sentry/vue";

library.add(faUserSecret, faInfo, faInfoCircle)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueCompositionAPI)
Vue.use(PortalVue)

Vue.use(VueClipboard)

import 'bootstrap/dist/css/bootstrap.css'
import '@/assets/sass/app.scss'

Vue.config.productionTip = false

Vue.use(Vuelidate)

Vue.use(VueGAPI, googleConfig);

Vue.use(VueContentPlaceholders)

Vue.use(VueLazyload)

Vue.use(VueMeta)

Vue.use(VueGtm, {
  id: "GTM-NTB8R92",
  defer: true,
  enabled: true,
  // debug: process.env.VUE_APP_API_DEBUG,
  debug: false,
  vueRouter: router,
  trackOnNextTick: false,
});

bootstrap.then(function() {
  Sentry.init({
    Vue,
    dsn: "https://d5a8f5f9f3ca09afcb23dfaaabcadb7f@o4504527662350336.ingest.sentry.io/4505901796687872",
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", /^https:\/\/api\.cyberclass\.com\.br\/api/],
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
      new Sentry.Replay(),
    ],
    enabled: process.env.VUE_APP_ENV !== 'development',
    // Performance Monitoring
    tracesSampleRate: 0.1, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });

  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app')
})
